import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class MarianaInAppAd extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'MarianaInAppAd'
  // Define default properties here
  static instanceDefaults() {
    return {
      active: true,
      enableAt: null,
      disableAt: null,
    }
  }
}
const servicePath = 'mariana/in-app-ad'
const servicePlugin = makeServicePlugin({
  Model: MarianaInAppAd,
  namespace: 'mariana-in-app-ad',
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin